export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/baby_icon.b8f80268.svg","height":17,"width":19,"blurWidth":0,"blurHeight":0};